import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "./index.css";
import "./i18n";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { HeroModeProvider } from "./contexts/HeroModeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <HeroModeProvider>
            <App />
            <Toaster
              position="top-center"
              richColors
              toastOptions={{
                style: { fontFamily: "Inter, system-ui, sans-serif" },
              }}
            />
          </HeroModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
